import { useEffect, useState } from "react"

export default function SellBox() {
    const [display, setDisplay] = useState(false)
    const [price, setPrice] = useState()
    useEffect(() => {
        //console.log('lalal')
        const controlBox = ({ detail }) => {
            setDisplay(detail);
            //console.log(detail)
        }
        window.addEventListener('displaySellBox', controlBox)
        return () => window.removeEventListener('displaySellBox', controlBox)
    }, [display])

    return (<>
        <div className={`absolute top-0 left-0 w-full h-full bg-black bg-opacity-60 z-50 ${display ? "block" : "hidden"}`}>
            <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <div className="w-[40rem] bg-third px-[4.6rem] pb-[4rem] pt-[2.7rem] rounded-[1rem] ">
                    <p className="text-[2.4rem] text-primary font-normal mb-[1.2rem] font-bakbak">SELL</p>
                    <p className="text-[1.6rem] text-white leading-[2.4rem] font-bakbak mb-[0.8rem]">PRICE</p>
                    <input className="h-[5rem] w-full rounded-[1rem] text-[1.6rem] text-gray-600 font-bakbak px-[1.6rem] py-[0.8rem] bg-black bg-opacity-50 mb-[2.4rem]" onChange={(e) => setPrice(e.value)} max={15} type={'number'} name="price" value={price} />
                    <div className="flex justify-between">
                        <button onClick={() => setDisplay(false)} className="items-center border-2 border-[#888B8E] rounded-full w-[14rem] flex justify-center py-[0.8rem] text-white text-[1.6rem] bg-transparent sm:hover:opacity-50 active:opacity-50 transition-all duration-300 font-bakbak">CANCLE</button>
                        <button onClick={() => setDisplay(false)} className=" items-center rounded-full w-[14rem] flex justify-center py-[0.8rem] text-white text-[1.6rem] bg-primary sm:hover:opacity-50 active:opacity-50 transition-all duration-300 font-bakbak">OK</button>
                    </div>
                </div>
            </div>
        </div>
    </>)
}